module.exports = __webpack_public_path__ + "static/media/icon_calender_arrow_right.5f55b02a.svg";